import React, { useState, useEffect } from 'react'
import { Box, Typography, CircularProgress } from '@material-ui/core'
import { tokenRequest, codeRequest } from '../api'
import { useHistory } from 'react-router-dom'
import Card from '../pages/common/Card'
import { Page } from '../const'
import { isAuthenticated } from '../Controller'

export function Authentication() {
  const [error, setError] = useState(false)
  const history = useHistory()

  useEffect(() => {
    const urlParams = window.location.search.slice(1)
    if (!urlParams) {
      codeRequest()
    } else {
      tokenRequest().then(response => {
        if (response && response.success) {
          isAuthenticated().then(authenticated => {
            if (authenticated) {
              history.push(Page.deployment)
            } else {
              setError(true)
            }
          })
        } else {
          setError(true)
        }
      })
    }
  }, [history])

  if (error) {
    return (
      <Card title='Error'>
        <Typography variant='h6'>Something went wrong! Please try again!</Typography>
      </Card>
    )
  } else {
    return (
      <Box className='center'>
        <Box className='centerSpinner'>
          <CircularProgress className='spinner' size={60} />
          <Typography variant='subtitle1'>Authenticating...</Typography>
        </Box>
      </Box>
    )
  }
}

export default Authentication
